import { render } from "./AdminUserEdit.vue?vue&type=template&id=681539b4&scoped=true&ts=true"
import script from "./AdminUserEdit.vue?vue&type=script&lang=ts"
export * from "./AdminUserEdit.vue?vue&type=script&lang=ts"

import "./AdminUserEdit.vue?vue&type=style&index=0&id=681539b4&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-681539b4"]])

export default __exports__